export default {
  mailtpl: {
    default: "Modèle de notification | Modèles de notification",
    title: "Modèles de notification",
    list: {
      page_title: "Liste des modèles de notification"
    },
    show: {
      page_title: "Modèle de notification :"
    }
  }
}
